const allowedKeysRegex = /^\d{1}$/

export const incomeMask = [
  allowedKeysRegex,
  allowedKeysRegex,
  allowedKeysRegex,
  allowedKeysRegex,
  allowedKeysRegex,
  allowedKeysRegex,
  allowedKeysRegex,
  allowedKeysRegex,
  allowedKeysRegex,
]
